import { cn } from '@/lib/utils';
import { FileText, Video } from 'lucide-react';

interface ScoreBadgeProps {
  score: number;
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  className?: string;
  type?: 'cv' | 'interview';
}

export function ScoreBadge({ score, size = 'md', label, className, type = 'cv' }: ScoreBadgeProps) {
  const getScoreStyle = (s: number) => {
    if (s >= 80) return 'bg-success/5 text-success border border-success/40';
    if (s >= 60) return 'bg-warning/5 text-warning border border-warning/40';
    return 'bg-destructive/5 text-destructive border border-destructive/40';
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-lg',
  };

  return (
    <div className={cn('flex flex-col items-center gap-1', className)}>
      <span
        className={cn(
          'inline-flex items-center justify-center gap-1 min-w-[4.5rem] rounded-full font-bold tabular-nums',
          getScoreStyle(score),
          sizeClasses[size],
        )}
      >
        {type === 'interview' ? <Video className="w-3.5 h-3.5 shrink-0" /> : <FileText className="w-3.5 h-3.5 shrink-0" />}
        <span>{score}%</span>
      </span>
      {label && <span className="text-[10px] font-medium text-muted-foreground uppercase tracking-wider">{label}</span>}
    </div>
  );
}
